export const modifierList = [
  '1-col',
  '2-cols',
  '3-cols-tablet',
  '2-cols-tablet',
  '4-cols-desktop',
  '5-cols-desktop',
  'with-show-more',
  'no-border',
  'with-square-options',
  'single-option',
];
